import React from 'react'
import { Link } from 'react-router-dom'
import { Calendar, User, ArrowRight } from 'lucide-react'

const BlogPage = () => {
  const blogPosts = [
    {
      slug: 'ai-chatbots-transform-customer-service',
      title: 'How AI Chatbots Are Transforming Customer Service in 2025',
      excerpt: 'Discover how AI-powered chatbots are revolutionizing customer support, reducing response times by 80%, and improving customer satisfaction scores across industries.',
      author: 'Sarah Johnson',
      date: 'January 15, 2025',
      category: 'AI Technology',
      image: 'https://images.pexels.com/photos/8438918/pexels-photo-8438918.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '5 min read'
    },
    {
      slug: 'voice-ai-agents-future-business',
      title: 'Voice AI Agents: The Future of Business Communication',
      excerpt: 'Learn why voice AI agents are becoming essential for modern businesses, handling thousands of calls simultaneously while maintaining natural conversations.',
      author: 'Michael Chen',
      date: 'January 12, 2025',
      category: 'Voice AI',
      image: 'https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '7 min read'
    },
    {
      slug: 'roi-ai-customer-support',
      title: 'Calculating ROI: The Real Cost Savings of AI Customer Support',
      excerpt: 'A comprehensive analysis of how businesses save an average of $300,000 annually by implementing AI chatbots and voice agents for customer support.',
      author: 'Emily Rodriguez',
      date: 'January 10, 2025',
      category: 'Business Strategy',
      image: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '6 min read'
    },
    {
      slug: 'multilingual-ai-agents',
      title: 'Breaking Language Barriers: Multilingual AI Agents',
      excerpt: 'Explore how AI agents supporting 50+ languages are helping businesses expand globally and serve diverse customer bases without hiring multilingual staff.',
      author: 'David Kim',
      date: 'January 8, 2025',
      category: 'Global Business',
      image: 'https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '5 min read'
    },
    {
      slug: 'ai-agents-ecommerce',
      title: '10 Ways AI Agents Boost E-commerce Sales',
      excerpt: 'From personalized product recommendations to instant order tracking, discover how AI agents are increasing e-commerce conversion rates by up to 40%.',
      author: 'Lisa Anderson',
      date: 'January 5, 2025',
      category: 'E-commerce',
      image: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '8 min read'
    },
    {
      slug: 'implementing-ai-chatbot-guide',
      title: 'The Complete Guide to Implementing Your First AI Chatbot',
      excerpt: 'A step-by-step guide for businesses looking to deploy their first AI chatbot, from planning and setup to optimization and scaling.',
      author: 'James Wilson',
      date: 'January 3, 2025',
      category: 'Implementation',
      image: 'https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=800',
      readTime: '10 min read'
    }
  ]

  return (
    <main data-component-path="client/src/pages/BlogPage.jsx" data-component-line="76:4" data-component-id="client/src/pages/BlogPage.jsx:76:4" className="pt-20 bg-gray-50 min-h-screen">
      <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="77:6" data-component-id="client/src/pages/BlogPage.jsx:77:6" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="78:8" data-component-id="client/src/pages/BlogPage.jsx:78:8" className="text-center mb-16">
          <h1 data-component-path="client/src/pages/BlogPage.jsx" data-component-line="79:10" data-component-id="client/src/pages/BlogPage.jsx:79:10" className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            HelplineAgent Blog
          </h1>
          <p data-component-path="client/src/pages/BlogPage.jsx" data-component-line="82:10" data-component-id="client/src/pages/BlogPage.jsx:82:10" className="text-xl text-gray-600 max-w-3xl mx-auto">
            Insights, guides, and best practices for AI-powered customer support
          </p>
        </div>

        <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="87:8" data-component-id="client/src/pages/BlogPage.jsx:87:8" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article data-component-path="client/src/pages/BlogPage.jsx" data-component-line="89:12" data-component-id="client/src/pages/BlogPage.jsx:89:12"
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 group"
            >
              <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="93:14" data-component-id="client/src/pages/BlogPage.jsx:93:14" className="relative h-48 overflow-hidden">
                <img data-component-path="client/src/pages/BlogPage.jsx" data-component-line="94:16" data-component-id="client/src/pages/BlogPage.jsx:94:16"
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800'
                  }}
                />
                <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="103:16" data-component-id="client/src/pages/BlogPage.jsx:103:16" className="absolute top-4 left-4">
                  <span data-component-path="client/src/pages/BlogPage.jsx" data-component-line="104:18" data-component-id="client/src/pages/BlogPage.jsx:104:18" className="bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                    {post.category}
                  </span>
                </div>
              </div>

              <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="110:14" data-component-id="client/src/pages/BlogPage.jsx:110:14" className="p-6">
                <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="111:16" data-component-id="client/src/pages/BlogPage.jsx:111:16" className="flex items-center gap-4 text-sm text-gray-600 mb-3">
                  <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="112:18" data-component-id="client/src/pages/BlogPage.jsx:112:18" className="flex items-center gap-1">
                    <Calendar data-component-path="client/src/pages/BlogPage.jsx" data-component-line="113:20" data-component-id="client/src/pages/BlogPage.jsx:113:20" className="w-4 h-4" />
                    {post.date}
                  </div>
                  <span data-component-path="client/src/pages/BlogPage.jsx" data-component-line="116:18" data-component-id="client/src/pages/BlogPage.jsx:116:18">•</span>
                  <span data-component-path="client/src/pages/BlogPage.jsx" data-component-line="117:18" data-component-id="client/src/pages/BlogPage.jsx:117:18">{post.readTime}</span>
                </div>

                <h2 data-component-path="client/src/pages/BlogPage.jsx" data-component-line="120:16" data-component-id="client/src/pages/BlogPage.jsx:120:16" className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {post.title}
                </h2>

                <p data-component-path="client/src/pages/BlogPage.jsx" data-component-line="124:16" data-component-id="client/src/pages/BlogPage.jsx:124:16" className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>

                <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="128:16" data-component-id="client/src/pages/BlogPage.jsx:128:16" className="flex items-center justify-between">
                  <div data-component-path="client/src/pages/BlogPage.jsx" data-component-line="129:18" data-component-id="client/src/pages/BlogPage.jsx:129:18" className="flex items-center gap-2">
                    <User data-component-path="client/src/pages/BlogPage.jsx" data-component-line="130:20" data-component-id="client/src/pages/BlogPage.jsx:130:20" className="w-4 h-4 text-gray-500" />
                    <span data-component-path="client/src/pages/BlogPage.jsx" data-component-line="131:20" data-component-id="client/src/pages/BlogPage.jsx:131:20" className="text-sm text-gray-600">{post.author}</span>
                  </div>

                  <Link data-component-path="client/src/pages/BlogPage.jsx" data-component-line="134:18" data-component-id="client/src/pages/BlogPage.jsx:134:18"
                    to={`/blog/${post.slug}`}
                    className="flex items-center gap-1 text-blue-600 hover:text-blue-700 font-medium text-sm group-hover:gap-2 transition-all"
                  >
                    Read More
                    <ArrowRight data-component-path="client/src/pages/BlogPage.jsx" data-component-line="139:20" data-component-id="client/src/pages/BlogPage.jsx:139:20" className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </main>
  )
}

export default BlogPage